import gql from "graphql-tag"

export const CREATE_OR_UPDATE_LEDYER_CONFIG = gql`
  mutation createOrUpdateLedyerConfig(
    $id: ID!
    $ledyerConfig:InputLedyerConfig!
  ) {
    createOrUpdateLedyerConfig(
      id: $id
      ledyerConfig: $ledyerConfig
    ) {
      id
    }
  }
`
